import type { RouteDefinition } from "../route-definition.ts";

export const adminResearchRoutes = {
  "admin.experienceRequestsAnalytics": {
    path: "/admin/research/experience-requests/analytics",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.experienceRequestResults": {
    path: "/admin/research/experience-requests/:requestId/results",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.experienceRequestEpisodes": {
    path: "/admin/research/experience-requests/:requestId/episodes",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.experienceRequestSetup": {
    path: "/admin/research/experience-requests/:requestId/setup",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.comparisons": {
    path: "/admin/research/comparisons",
    scope: "static",
    bucket: "admin",
    entry: "compatibility",
    disposition: "resolver",
  },
  "admin.evaluations": {
    path: "/admin/research/evaluations",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.experienceRequests": {
    path: "/admin/research/experience-requests",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.comparison": {
    path: "/admin/research/comparisons/:comparisonId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.newExperienceRequest": {
    path: "/admin/research/experience-requests/new",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.experienceRequest": {
    path: "/admin/research/experience-requests/:requestId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
} as const satisfies Record<string, RouteDefinition>;
